<div class="container-fluid">
  <app-header titleText="SMS Summary Report" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null" class="container">
    <div class="row">
      <h5 class="col-sm-12" i18n>Please provide report criteria</h5>
    </div>
  </div>
  <div *ngIf="report">
    <div class="row header-text">

      <div class="col-md-4">
        <app-dealer-logo></app-dealer-logo>
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <span i18n>REPORT DEFINED:</span><br />
          <ng-template [ngIf]="parameters.startDate"><span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br /></ng-template>
        </p>
      </div>

    </div>

    <div class="content">
      <div class="quote-month-summary">
        <h2 i18n>SMS Summary</h2>
        <div>
          <table class="table table-bidit">
            <thead>
              <tr>
                <th i18n>Sender</th>
                <th i18n>Date</th>
                <th i18n>Subject</th>
                <th i18n>Recipient</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-detail [ngForOf]="report">
                <tr>
                  <td>
                    {{detail.createdBy.firstName}} {{detail.createdBy.lastName}}
                  </td>
                  <td>
                    {{detail.messagingEvent_Created | date: 'M/d/yyyy HH:mm'}}
                  </td>
                  <td>{{detail.messagingEvent_Subject}}</td>
                  <td>
                    {{detail.messagingEvent_To}}
                    <div *ngIf="!detail.messagingEvent_To">
                      None
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr *ngFor="let message of detail.messages" class="detail-row">
                  <td></td>
                  <td>
                    {{message.messagingEventMessage_Timestamp * 1000 | date:'M/d/yyyy HH:mm'}}
                  </td>
                  <td colspan="2">
                    {{message.messagingEventMessage_Event}}                 

                  </td>
                  <td>
                    <a href="javascript:void(0)" (click)="showDetails($event, message)">
                      Show Details
                    </a>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

